import React from 'react'
import { browserHistory } from 'react-router'
import common from '../Common/Common.scss'
import Challenges from './Challenges'
import Games from './Games'
import VersusGames from './VersusGames'

class GameList extends React.Component {

  componentWillMount () {
    window.scrollTo(0, 0)
  }

  setList (name) {
    const { toggleSidebar } = this.props
    const listName = name === 'challenges' ? name : `list_${name}`
    browserHistory.push(listName)
    toggleSidebar(false)
  }

  render () {
    const { gameList, baseUrl, username, challengeModal, openChallengeModal, closeChallengeModal,
            viewChallengeModal, openViewChallengeModal, closeViewChallengeModal, openAlertModal } = this.props
    return (
      <div className={common.gameList}>
        <ul className={common.gameTabs}>
          <li onClick={() => this.setList('solo')} className={gameList === 'solo' && common.active}>Solo</li>
          <li onClick={() => this.setList('versus')} className={gameList === 'versus' && common.active}>Versus</li>
          <li onClick={() => this.setList('challenges')} className={gameList === 'challenges' && common.active}>Challenges</li>
        </ul>
        {gameList === 'solo' && <Games type='solo' baseUrl={baseUrl} username={username} />}
        {gameList === 'versus' && <Games type='multi' baseUrl={baseUrl} username={username} challengeModal={challengeModal} openChallengeModal={openChallengeModal} closeChallengeModal={closeChallengeModal} />}
        {gameList === 'challenges' && <Challenges baseUrl={baseUrl} username={username} challengeModal={challengeModal} openChallengeModal={openChallengeModal} closeChallengeModal={closeChallengeModal} viewChallengeModal={viewChallengeModal} openViewChallengeModal={openViewChallengeModal} closeViewChallengeModal={closeViewChallengeModal} openAlertModal={openAlertModal} />}
      </div>
    )
  }
}

export default GameList



/** WEBPACK FOOTER **
 ** ./src/components/GameList/GameList.js
 **/